/**
 * Offer bundle compact preview — hero/grid modes (PB-FND-34).
 */
(function (global) {
  'use strict';

  function patchProductBuilder() {
    var pb = global.productBuilder;
    if (!pb) return;

    /* MODULE: OFFER BUNDLE COMPACT PREVIEW GRID — layout spec + product thumbnail grid */
      Object.assign(pb, {
        bundlePreviewHasCustomImage: function(bundle) {
          if (!bundle) return false;
          var custom = bundle.image != null ? String(bundle.image).trim() : '';
          return custom.length > 0;
        },
    
        getBundlePreviewGridSpec: function(itemCount) {
          var n = Math.max(0, Number(itemCount) || 0);
          if (n > 9) {
            return {
              cols: 3,
              rows: 3,
              productSlots: 8,
              overflowCount: n - 8,
              hasOverflow: true
            };
          }
          var cols;
          var rows;
          if (n <= 1) {
            cols = 1;
            rows = 1;
          } else if (n === 2) {
            cols = 2;
            rows = 1;
          } else if (n === 3) {
            cols = 3;
            rows = 1;
          } else if (n === 4) {
            cols = 2;
            rows = 2;
          } else if (n <= 6) {
            cols = 3;
            rows = 2;
          } else {
            cols = 3;
            rows = 3;
          }
          return {
            cols: cols,
            rows: rows,
            productSlots: n,
            overflowCount: 0,
            hasOverflow: false
          };
        },
    
        getBundlePreviewGridItems: function(bundle, mainProduct) {
          if (!bundle || !bundle.items || !bundle.items.length) return [];
          var pb = this;
          var items = bundle.items;
          var displayIdxs =
            typeof pb.getBundleDisplayOrderIndices === 'function'
              ? pb.getBundleDisplayOrderIndices(bundle, mainProduct)
              : items.map(function(_, i) { return i; });
          var ordered = [];
          for (var i = 0; i < displayIdxs.length; i++) {
            var item = items[displayIdxs[i]];
            if (item) ordered.push(item);
          }
          return ordered;
        },
    
        buildBundlePreviewGridSeparatorHtml: function() {
          return '<span class="pb-bundle-preview__sep" aria-hidden="true">+</span>';
        },
    
        buildBundlePreviewGridCellHtml: function(item, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var title = item && item.title != null ? String(item.title) : '';
          var img =
            item && item.image != null ? String(item.image).trim() : '';
          var mediaInner = `<img${img ? ` src="${esc(img)}"` : ''} class="pb-bundle-preview__cell-img" width="120" height="160" loading="lazy" decoding="async" alt="${esc(title)}">` +
            '<span class="store-media-fallback" role="img" aria-label="Artwork unavailable" hidden>▧</span>';
          return (
            `<div class="pb-bundle-preview__cell">` +
            `<div class="pb-bundle-preview__cell-media" data-store-bundle-media data-store-media data-state="empty">${mediaInner}</div>` +
            `</div>`
          );
        },
    
        buildBundlePreviewOverflowCellHtml: function(overflowCount, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var label = '+' + String(Math.max(0, Number(overflowCount) || 0));
          return (
            `<div class="pb-bundle-preview__cell pb-bundle-preview__cell--overflow">` +
            `<div class="pb-bundle-preview__cell-media pb-bundle-preview__overflow" aria-label="${esc(label + ' more items')}">` +
            `<span class="pb-bundle-preview__overflow-label">${esc(label)}</span>` +
            `</div>` +
            `</div>`
          );
        },
    
        buildBundlePreviewGridRowHtml: function(rowItems, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var center = !!opts.center;
          var pb = this;
          var rowClass = center
            ? 'pb-bundle-preview__grid-row pb-bundle-preview__grid-row--center'
            : 'pb-bundle-preview__grid-row';
          var parts = [];
          for (var i = 0; i < rowItems.length; i++) {
            if (i > 0) {
              parts.push(pb.buildBundlePreviewGridSeparatorHtml());
            }
            var entry = rowItems[i];
            if (entry && entry.overflow) {
              parts.push(
                pb.buildBundlePreviewOverflowCellHtml(entry.overflowCount, { esc: esc })
              );
            } else {
              parts.push(pb.buildBundlePreviewGridCellHtml(entry, { esc: esc }));
            }
          }
          return `<div class="${rowClass}">${parts.join('')}</div>`;
        },
    
        buildBundlePreviewGridRowsFromOrdered: function(ordered, spec, esc) {
          var pb = this;
          var cols = spec.cols;
          var slots = spec.hasOverflow ? spec.productSlots : ordered.length;
          var entries = [];
          var i;
          for (i = 0; i < slots; i++) {
            entries.push(ordered[i]);
          }
          if (spec.hasOverflow) {
            entries.push({ overflow: true, overflowCount: spec.overflowCount });
          }
          var rows = [];
          for (i = 0; i < entries.length; i += cols) {
            rows.push(entries.slice(i, i + cols));
          }
          var rowsHtml = '';
          for (i = 0; i < rows.length; i++) {
            var row = rows[i];
            var isLast = i === rows.length - 1;
            var center = isLast && row.length < cols && row.length > 0;
            rowsHtml += pb.buildBundlePreviewGridRowHtml(row, {
              esc: esc,
              center: center
            });
          }
          return rowsHtml;
        },
    
        buildBundlePreviewGridMediaHtml: function(bundle, mainProduct, esc) {
          esc = esc || this.escapeAttr.bind(this);
          var pb = this;
          var ordered = pb.getBundlePreviewGridItems(bundle, mainProduct);
          var n = ordered.length;
          if (!n) {
            return '<div class="pb-bundle-preview__grid-rows"></div>';
          }
          var spec = pb.getBundlePreviewGridSpec(n);
          var rowsHtml = pb.buildBundlePreviewGridRowsFromOrdered(ordered, spec, esc);
          return (
            `<div class="pb-bundle-preview__grid-rows" style="--pb-grid-cols: ${spec.cols}">` +
            rowsHtml +
            `</div>`
          );
        }
      });
    
        /* MODULE: OFFER BUNDLE COMPACT PREVIEW — compact inner markup + hero/grid modes */
      Object.assign(pb, {
        resolveBundlePreviewImage: function(bundle) {
          if (!bundle) return '';
          var custom = bundle.image != null ? String(bundle.image).trim() : '';
          return custom;
        },
    
        /** Keep full artwork visible regardless of source orientation. */
        applyBundlePreviewHeroImageFit: function(img) {
          if (img) img.style.objectFit = 'contain';
        },

        // Retain the existing offers-render lifecycle hook; both compact modes adopt shared state.
        syncBundlePreviewHeroImageFits: function(root) {
          root = root || document.getElementById('offers-list-js');
          if (!root || !global.PBStoreMedia) return;
          // Expanded tier rows retain resolved URLs and the existing one-shot product fallback.
          // Keep an attached image's native frame, or reserve the same slot for a bare product image.
          root.querySelectorAll('.pb-offer-bundle-tier .pb-t-img').forEach(function(img) {
            if (img.closest('[data-store-bundle-media]')) return;
            var frame = img.parentElement;
            if (frame.classList.contains('pb-attached-media-thumb__frame')) {
              frame.classList.remove('pb-attached-media-thumb__frame');
            } else {
              frame = img.ownerDocument.createElement('span');
              img.parentElement.insertBefore(frame, img);
              frame.appendChild(img);
            }
            frame.classList.add('pb-bundle-preview__row-media');
            frame.setAttribute('data-store-bundle-media', '');
            frame.setAttribute('data-store-media', '');
            frame.dataset.state = 'empty';
            var fallback = img.ownerDocument.createElement('span');
            fallback.className = 'store-media-fallback';
            fallback.setAttribute('role', 'img');
            fallback.setAttribute('aria-label', 'Artwork unavailable');
            fallback.textContent = '▧';
            fallback.hidden = true;
            frame.appendChild(fallback);
          });
          var frames = root.querySelectorAll('[data-store-bundle-media]');
          for (var i = 0; i < frames.length; i++) {
            var img = frames[i].querySelector('img');
            global.PBStoreMedia.syncStoreMedia(frames[i], img.getAttribute('src'));
          }
        },

        buildBundleSaveBadgeHtml: function(totalSavedCents, formatNumber, esc) {
          esc = esc || this.escapeAttr.bind(this);
          var cents = totalSavedCents != null ? Number(totalSavedCents) : 0;
          if (!cents || cents <= 0 || typeof formatNumber !== 'function') return '';
          return `<span class="pb-bundle-save">SAVE ${esc(formatNumber(cents))}</span>`;
        },
    
        buildBundleSaveTabHtml: function(totalSavedCents, formatNumber, esc) {
          esc = esc || this.escapeAttr.bind(this);
          var cents = totalSavedCents != null ? Number(totalSavedCents) : 0;
          if (!cents || cents <= 0 || typeof formatNumber !== 'function') return '';
          return `<div class="pb-bundle-save-tab">SAVE ${esc(formatNumber(cents))}</div>`;
        },
    
        /** Card-level save ribbon — rendered once on the tier card so it persists across compact + expanded states. */
        buildBundleSaveRibbonHtml: function(totalSavedCents, formatNumber, esc) {
          esc = esc || this.escapeAttr.bind(this);
          var cents = totalSavedCents != null ? Number(totalSavedCents) : 0;
          if (!cents || cents <= 0 || typeof formatNumber !== 'function') return '';
          return `<div class="pb-bundle-save-ribbon" aria-hidden="true">SAVE ${esc(formatNumber(cents))}</div>`;
        },
    
        buildBundlePreviewDescHtml: function(bundle, esc, opts) {
          opts = opts || {};
          esc = esc || this.escapeAttr.bind(this);
          var descClass = opts.descClass || 'pb-bundle-preview__desc';
          var desc =
            bundle.description != null && String(bundle.description).trim() !== ''
              ? String(bundle.description).trim()
              : '';
          if (desc) {
            return `<p class="${descClass}">${esc(desc)}</p>`;
          }
          if (opts.allowFallback === false) return '';
          var n =
            bundle.items && bundle.items.length
              ? bundle.items.length
              : 0;
          if (!n) return '';
          var label = n === 1 ? 'Includes 1 item' : 'Includes ' + n + ' items';
          return `<p class="${descClass}">${esc(label)}</p>`;
        },
    
        buildBundlePreviewHeaderHtml: function(bundle, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var formatNumber = opts.formatNumber;
          var bundleHeaderPrice = opts.bundleHeaderPrice || '';
          var totalSavedCents = opts.totalSavedCents != null ? opts.totalSavedCents : 0;
          var pb = this;
          var descHtml = pb.buildBundlePreviewDescHtml(bundle, esc, {
            allowFallback: true,
            descClass: 'pb-bundle-preview__header-desc'
          });
          // Save indicator is rendered as a card-level corner ribbon (see buildBundleSaveRibbonHtml),
          // not inside the header, so it persists across both compact and expanded states.
          return (
            `<div class="pb-bundle-header pb-bundle-preview__header">` +
            `<div class="pb-bundle-title-group">` +
            `<div class="pb-bundle-radio"></div>` +
            `<div class="pb-bundle-preview__title-block">` +
            `<span class="pb-bundle-name">${esc(bundle.title)}</span>` +
            descHtml +
            `</div>` +
            `</div>` +
            `<div class="pb-bundle-preview__header-aside">` +
            `<div class="pb-bundle-price-group">${bundleHeaderPrice}</div>` +
            `</div>` +
            `</div>`
          );
        },
    
        buildBundlePreviewHeroInnerHtml: function(bundle, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var imageUrl = this.resolveBundlePreviewImage(bundle);
          var mediaHtml = `<img${imageUrl ? ` src="${esc(imageUrl)}"` : ''} class="pb-bundle-preview__img" width="400" height="400" loading="lazy" decoding="async" alt="">` +
            '<span class="store-media-fallback" role="img" aria-label="Artwork unavailable" hidden>Artwork unavailable</span>';
          return (
            `<div class="pb-bundle-preview__inner">` +
            `<div class="pb-bundle-preview__media" data-store-bundle-media data-store-media data-state="empty">${mediaHtml}</div>` +
            `</div>`
          );
        },
    
        buildBundlePreviewGridInnerHtml: function(bundle, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var mainProduct = opts.mainProduct;
          var pb = this;
          var gridHtml =
            typeof pb.buildBundlePreviewGridMediaHtml === 'function'
              ? pb.buildBundlePreviewGridMediaHtml(bundle, mainProduct, esc)
              : '';
          return (
            `<div class="pb-bundle-preview__inner">` +
            `<div class="pb-bundle-preview__media">${gridHtml}</div>` +
            `</div>`
          );
        },
    
        /** Inner compact preview only (.pb-bundle-preview) — wrapped by dual-DOM tier panels in buildOffersHtml. */
        buildBundleCompactPreviewHtml: function(bundle, opts) {
          opts = opts || {};
          var esc = opts.esc || this.escapeAttr.bind(this);
          var bundleHeaderPrice = opts.bundleHeaderPrice || '';
          var pb = this;
          var useHero =
            typeof pb.bundlePreviewHasCustomImage === 'function'
              ? pb.bundlePreviewHasCustomImage(bundle)
              : !!pb.resolveBundlePreviewImage(bundle);
          var modeClass = useHero
            ? 'pb-bundle-preview--hero'
            : 'pb-bundle-preview--grid';
          var headerHtml = pb.buildBundlePreviewHeaderHtml(bundle, opts);
          var innerHtml = useHero
            ? pb.buildBundlePreviewHeroInnerHtml(bundle, opts)
            : pb.buildBundlePreviewGridInnerHtml(bundle, opts);
    
          return (
            `<div class="pb-bundle-preview ${modeClass}">` +
            headerHtml +
            innerHtml +
            `</div>`
          );
        },
    
        syncBundleTierExpandedState: function() {
          var s = window.builderState;
          var sid = s && s.bundle && s.bundle.selectedId ? String(s.bundle.selectedId) : '';
          document.querySelectorAll('.pb-offer-bundle-tier').forEach(function(tier) {
            var tid = tier.getAttribute('data-pb-bundle-id') || '';
            var isSelected = sid !== '' && String(tid) === sid;
            tier.classList.toggle('selected', isSelected);
            tier.setAttribute('aria-expanded', isSelected ? 'true' : 'false');
          });
        }
      });
  }

  patchProductBuilder();
})(typeof window !== 'undefined' ? window : globalThis);
